/* GIZA MILLS — storefront behaviour (replaces the React interactivity).
   Header scroll state · slide menu · cart drawer (AJAX + Section Rendering API) ·
   add-to-cart + analytics (Klaviyo / Meta / GA4) · scroll-reveal · consent banner. */
(function () {
  'use strict';
  var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Header: dark/scrolled state ---------- */
  function initHeader() {
    var header = document.getElementById('gm-header');
    var rootEl = document.getElementById('gm-header-root');
    if (!header || !rootEl) return;
    var overHero = rootEl.getAttribute('data-over-hero') === 'true';
    var menuOpen = function () { return document.documentElement.classList.contains('gm-menu-open'); };
    function sync() {
      var dark = !overHero || window.scrollY > 12 || menuOpen();
      header.classList.toggle('is-dark', dark);
      var d = $('[data-gm-logo-dark]'), c = $('[data-gm-logo-cream]');
      if (d && c) { d.classList.toggle('hidden', !dark); c.classList.toggle('hidden', dark); }
    }
    sync();
    window.addEventListener('scroll', sync, { passive: true });
    window.__gmHeaderSync = sync;
  }

  /* ---------- Slide-in menu ---------- */
  function initMenu() {
    var menu = $('[data-gm-menu]'), overlay = $('[data-gm-menu-overlay]');
    if (!menu) return;
    function open() {
      menu.classList.remove('-translate-x-full'); menu.classList.add('translate-x-0');
      menu.setAttribute('aria-hidden', 'false');
      if (overlay) { overlay.classList.remove('opacity-0', 'pointer-events-none'); overlay.classList.add('opacity-100'); }
      document.documentElement.classList.add('gm-menu-open');
      document.body.style.overflow = 'hidden';
      if (window.__gmHeaderSync) window.__gmHeaderSync();
    }
    function close() {
      menu.classList.add('-translate-x-full'); menu.classList.remove('translate-x-0');
      menu.setAttribute('aria-hidden', 'true');
      if (overlay) { overlay.classList.add('opacity-0', 'pointer-events-none'); overlay.classList.remove('opacity-100'); }
      document.documentElement.classList.remove('gm-menu-open');
      document.body.style.overflow = '';
      if (window.__gmHeaderSync) window.__gmHeaderSync();
    }
    $$('[data-gm-menu-open]').forEach(function (b) { b.addEventListener('click', open); });
    $$('[data-gm-menu-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------- Cart drawer ---------- */
  function openCart() {
    var c = $('[data-gm-cart]'), o = $('[data-gm-cart-close]');
    if (!c) return;
    c.classList.remove('translate-x-full'); c.classList.add('translate-x-0');
    if (o) { o.classList.remove('opacity-0', 'pointer-events-none'); o.classList.add('opacity-100'); }
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    var c = $('[data-gm-cart]'), o = $('[data-gm-cart-close]');
    if (!c) return;
    c.classList.add('translate-x-full'); c.classList.remove('translate-x-0');
    if (o) { o.classList.add('opacity-0', 'pointer-events-none'); o.classList.remove('opacity-100'); }
    document.body.style.overflow = '';
  }
  window.GIZA = window.GIZA || {};
  window.GIZA.openCart = openCart;
  window.GIZA.closeCart = closeCart;

  function refreshCart() {
    return fetch(root + '?sections=gm-cart-drawer', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['gm-cart-drawer'];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-gm-cart-body]');
        var current = document.querySelector('[data-gm-cart-body]');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        bindCartButtons();
        return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        if (!cart) return;
        var badge = $('[data-gm-cart-count]');
        if (badge) { badge.textContent = cart.item_count; badge.classList.toggle('hidden', cart.item_count === 0); }
      });
  }
  window.GIZA.refreshCart = refreshCart;

  function bindCartButtons() {
    $$('[data-gm-cart-close]').forEach(function (b) { b.addEventListener('click', closeCart); });
    $$('[data-gm-cart-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); openCart(); }); });
    $$('[data-gm-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var key = b.getAttribute('data-gm-qty');
        var qty = b.getAttribute('data-qty');
        fetch(root + 'cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: parseInt(qty, 10) })
        }).then(function () { return refreshCart(); });
      });
    });
  }

  /* ---------- Add to cart (data-gm-add holds JSON of analytics fields) ---------- */
  function initAddToCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest ? e.target.closest('[data-gm-add-form]') : null;
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('[type=submit]');
      var fd = new FormData(form);
      if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = '…'; }
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
        .then(function (r) { return r.json(); })
        .then(function () {
          openCart();
          return refreshCart();
        })
        .then(function () {
          var meta = {};
          try { meta = JSON.parse(form.getAttribute('data-gm-analytics') || '{}'); } catch (x) {}
          if (window.GIZA.klaviyo) window.GIZA.klaviyo('Added to Cart', {
            $value: meta.price, ProductName: meta.title, Price: meta.price, CurrencyCode: meta.currency, ImageURL: meta.image, URL: meta.url, VariantName: meta.variant
          });
          if (window.GIZA.fbq) window.GIZA.fbq('AddToCart', { content_name: meta.title, content_ids: meta.handle ? [meta.handle] : undefined, content_type: 'product', value: meta.price, currency: meta.currency });
          if (window.GIZA.gtag) window.GIZA.gtag('add_to_cart', { currency: meta.currency, value: meta.price, items: [{ item_id: meta.handle, item_name: meta.title, item_variant: meta.variant, price: meta.price }] });
        })
        .catch(function () {})
        .then(function () { if (btn) { btn.disabled = false; if (btn.dataset.label) btn.textContent = btn.dataset.label; } });
    });
  }

  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    var els = $$('.reveal');
    if (!('IntersectionObserver' in window) || !els.length) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Consent ---------- */
  // The branded banner (snippets/gm-consent-banner.liquid) drives Shopify Customer Privacy on
  // click and loads PostHog on grant. Here we just load PostHog for returning visitors who
  // already granted (cookie gm_consent=granted). Meta/GA4/Klaviyo are gated by Customer Privacy.
  function initConsentGate() {
    if (/(?:^|;\s*)gm_consent=granted(?:;|$)/.test(document.cookie) && window.GIZA && window.GIZA.loadTracking) window.GIZA.loadTracking();
  }

  function init() { initHeader(); initMenu(); bindCartButtons(); initAddToCart(); initReveal(); initConsentGate(); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
